
 <div class="container d-flex align-items-center justify-content-center min-vh-100 py-4">
   <div class="row justify-content-center">

     <!-- Verification failed state -->
     <div *ngIf="verificationFailed" class="col-lg-9 h-100 overflow-auto">
       <div class="card shadow">
         <div class="card-header">
           <h2 class="mb-0 text-white">Passport Verification Failed</h2>
         </div>
         <div class="card-body">
           <div class="text-center">
             <h4><i class="fas fa-exclamation-circle text-danger me-2"></i> Unable to Verify Passport</h4>
             <p class="mt-3">Please contact our administrator for assistance with your passport verification.</p>
             <button class="btn btn-primary mt-4" (click)="clearError()">
               Try Again
             </button>
             <button
               class="btn btn-secondary mt-4"
               (click)="signOutAzureB2C()">
               <i class="fas fa-sign-out-alt"></i> Cancel
             </button>

           </div>
         </div>
       </div>
     </div>

     <!-- Verification success state -->
     <div *ngIf="verificationSuccess" class="col-lg-12 h-100 overflow-auto">
       <div class="card shadow">
         <div class="card-header bg-success">
           <h2 class="mb-0 text-white">Passport Verification Completed</h2>
         </div>
         <div class="card-body">
           <div class="text-center">
             <h4><i class="fas fa-check-circle text-success me-2"></i> Passport Verification successfully verified</h4>
             <p class="mt-3">Your passport has been successfully verified. <br> Please log in again to ensure your personal information is up to date.</p>
             <button
               class="btn btn-primary mt-4"
               (click)="signOutAzureB2C()">
               Go to login
             </button>
           </div>
         </div>
       </div>
     </div>

     <!-- Normal content when verification hasn't failed or succeeded -->
     <div *ngIf="!verificationFailed && !verificationSuccess" class="col-lg-6 h-100 overflow-auto">
        <div class="card shadow">
          <div class="card-header">
            <h2 class="mb-0 text-white">Passport Verification</h2>
          </div>

          <div class="card-body">
            <div class="mb-4">
              <h4>Consent for Storage of Passport Information</h4>
              <div class="p-4 rounded bg-light border overflow-auto shadow-sm" style="max-height: 350px;">
                <p class="mb-0">
                  Dear User,
                </p>
                <p class="mb-3">
                  To ensure the security and integrity of our services, and in accordance with our legal obligations, we require your explicit consent to temporarily store certain information from your passport after the verification process is complete.
                </p>

                <div class="mb-3 border rounded shadow-sm">
                  <div class="d-flex align-items-center p-3 bg-white" style="cursor: pointer;" (click)="toggleSection('secure')">
                    <h5 class="mb-0 text-nhc-orange fw-bold d-flex align-items-center">
                      <i class="fas me-3" [ngClass]="{'fa-chevron-down': !sections.secure, 'fa-chevron-up': sections.secure}"></i>
                      Why do we need to store your passport information?
                    </h5>
                  </div>
                  <div class="overflow-hidden transition-height" [ngClass]="{'border-top': sections.secure}" [style.max-height]="sections.secure ? '500px' : '0'">
                    <div class="p-3 bg-white">
                      <p>We will store your passport information (specifically your full name, date of birth, passport number, nationality, and expiry date) for the following purposes:</p>
                      <ul>
                        <li>For internal audit and compliance purposes.</li>
                        <li>To facilitate future, streamlined verification processes should they be required by law or our service terms (e.g., if you need to re-verify your identity after a period).</li>
                        <li>To prevent fraud and maintain the security of our platform.</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="mb-3 border rounded shadow-sm">
                  <div class="d-flex align-items-center p-3 bg-white" style="cursor: pointer;" (click)="toggleSection('required')">
                    <h5 class="mb-0 text-nhc-orange fw-bold d-flex align-items-center">
                      <i class="fas me-3" [ngClass]="{'fa-chevron-down': !sections.required, 'fa-chevron-up': sections.required}"></i>
                      What information will be stored?
                    </h5>
                  </div>
                  <div class="overflow-hidden transition-height" [ngClass]="{'border-top': sections.required}" [style.max-height]="sections.required ? '500px' : '0'">
                    <div class="p-3 bg-white">
                      <p>We will only store the essential data required for the purposes stated above. This includes:</p>
                      <ul>
                        <li>Given Name, Family Name, Date of Birth, Passport Number, Nationality, Issuing Country</li>
                      </ul>
                      <p>We will <strong>NOT</strong> store a copy of your passport image or any biometric data.</p>
                    </div>
                  </div>
                </div>

                <div class="mb-3 border rounded shadow-sm">
                  <div class="d-flex align-items-center p-3 bg-white" style="cursor: pointer;" (click)="toggleSection('privacy')">
                    <h5 class="mb-0 text-nhc-orange fw-bold d-flex align-items-center">
                      <i class="fas me-3" [ngClass]="{'fa-chevron-down': !sections.privacy, 'fa-chevron-up': sections.privacy}"></i>
                      How long will your information be stored?
                    </h5>
                  </div>
                  <div class="overflow-hidden transition-height" [ngClass]="{'border-top': sections.privacy}" [style.max-height]="sections.privacy ? '500px' : '0'">
                    <div class="p-3 bg-white">
                      <p>Your passport information will be securely stored for a period of <strong>one (1) year</strong> from the date of successful verification. After this period, your passport information will be permanently and irretrievably deleted from our systems.</p>
                    </div>
                  </div>
                </div>

                <div class="mb-3 border rounded shadow-sm">
                  <div class="d-flex align-items-center p-3 bg-white" style="cursor: pointer;" (click)="toggleSection('storage')">
                    <h5 class="mb-0 text-nhc-orange fw-bold d-flex align-items-center">
                      <i class="fas me-3" [ngClass]="{'fa-chevron-down': !sections.storage, 'fa-chevron-up': sections.storage}"></i>
                      Your Rights under GDPR
                    </h5>
                  </div>
                  <div class=" transition-height" [ngClass]="{'border-top': sections.storage}" [style.max-height]="sections.storage ? '500px' : '0'" style="overflow-y: auto;">
                    <div class="p-3 bg-white">
                      <p>Under the General Data Protection Regulation (GDPR), you have the following rights regarding your personal data:</p>
                      <ul>
                        <li>Right of Access: You have the right to request a copy of the personal data we hold about you.</li>
                        <li>Right to Rectification: You have the right to request that we correct any inaccurate or incomplete personal data.</li>
                        <li>Right to Erasure (Right to be Forgotten): You have the right to request the deletion of your personal data, subject to certain legal obligations we may have. Please note that while we will delete your data after one year as stated, you may request earlier deletion if permitted by law and our legitimate interests.</li>
                        <li>Right to Restriction of Processing: You have the right to request that we limit the way we use your personal data.</li>
                        <li>Right to Data Portability: You have the right to receive your personal data in a structured, commonly used, and machine-readable format.</li>
                        <li>Right to Object: You have the right to object to the processing of your personal data in certain circumstances.</li>
                        <li>Right to Withdraw Consent: You have the right to withdraw your consent at any time. Please be aware that withdrawing consent may impact your ability to use certain features of our application or services if the processing of passport information is essential for their provision.</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div class="mb-3 border rounded shadow-sm">
                  <div class="d-flex align-items-center p-3 bg-white" style="cursor: pointer;" (click)="toggleSection('security')">
                    <h5 class="mb-0 text-nhc-orange fw-bold d-flex align-items-center">
                      <i class="fas me-3" [ngClass]="{'fa-chevron-down': !sections.security, 'fa-chevron-up': sections.security}"></i>
                      Data Security
                    </h5>
                  </div>
                  <div class="overflow-hidden transition-height" [ngClass]="{'border-top': sections.security}" [style.max-height]="sections.security ? '500px' : '0'">
                    <div class="p-3 bg-white">
                      <p>We are committed to protecting your personal data. Your passport information will be stored securely and will only be accessible by authorized personnel for the purposes outlined above.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-check mb-4">
              <input
                type="checkbox"
                class="form-check-input"
                id="consentCheck"
                [(ngModel)]="consentChecked">
              <label class="form-check-label fw-medium" for="consentCheck">
                I have read and agree to the terms and conditions for passport verification.
              </label>
            </div>

            <div class="text-center">
              <button
                class="btn btn-primary"
                [disabled]="!consentChecked"
                (click)="startAuthFlow()">
                Passport Verification
              </button>
              <button
                class="btn btn-secondary"
                (click)="signOutAzureB2C()">
                <i class="fas fa-sign-out-alt"></i> Cancel
              </button>
            </div>

            <!-- Mock Verification Section -->
            <!--          <div class="mt-4 p-3 border rounded bg-light">-->
            <!--            <h5 class="mb-3">Mock Verification (For Testing)</h5>-->
            <!--            <div class="d-flex justify-content-center gap-3">-->
            <!--              <button-->
            <!--                class="btn btn-success"-->
            <!--                (click)="useMockVerification(true)">-->
            <!--                Mock Success-->
            <!--              </button>-->
            <!--              <button-->
            <!--                class="btn btn-danger"-->
            <!--                (click)="useMockVerification(false)">-->
            <!--                Mock Failure-->
            <!--              </button>-->
            <!--            </div>-->
            <!--          </div>-->
          </div>
        </div>
      </div>
   </div>
 </div>
